export default {"src":"/_next/static/media/Postural Dysfunctions.cf780220.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};